import React from 'react';
import Skeleton from '../../common/skeleton';

const CarouselSkeleton = () => (
  <div className="skeleton-container">
    <div className="chart-container">
      <div className="deductables-chart">
        <Skeleton
          height={90}
          width={90}
          count={1}
          circle={true}
          containerClassName={'skeleton-donut'}
        />
        <Skeleton
          height={12}
          count={1}
          containerClassName={'skeleton-rem-label'}
        />
        <Skeleton
          height={22}
          count={1}
          containerClassName={'skeleton-deductable-amount'}
        />
      </div>
      <div className="out-of-pocket-chart">
        <Skeleton
          height={90}
          width={90}
          count={1}
          circle={true}
          containerClassName={'skeleton-donut'}
        />
        <Skeleton
          height={12}
          count={1}
          containerClassName={'skeleton-rem-label'}
        />
        <Skeleton
          height={22}
          count={1}
          containerClassName={'skeleton-deductable-amount'}
        />
      </div>
    </div>
    <div className="card-footer">
      <div className="card-footer-content">
        <Skeleton height={20} count={1} containerClassName={'plan-title'} />
        <Skeleton height={12} count={1} containerClassName={'plan-name'} />
        <Skeleton height={14} count={1} containerClassName={'coverage-link'} />
      </div>
    </div>
  </div>
);

export default CarouselSkeleton;
